import { render, staticRenderFns } from "./settings-products.vue?vue&type=template&id=2352087e"
import script from "./settings-products.vue?vue&type=script&lang=js"
export * from "./settings-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports